$shm_hitalama_map_selectbox $shm_hitalama_map_float
	selected_links /$giper_baza_link
	style *
		^
		transition <= transition \none
	sub /
		^ sub_common
	sidebar /
	toolbar_content /
		<= Count $mol_view
			sub / <= count_title \
		<= Group $mol_button_minor
			hint \Group
			sub /
				<= Group_icon $mol_icon_group
			click? <=> grouping? null
		<= Delete $mol_button_minor
			hint @ \Delete
			sub /
				<= Delete_icon $mol_icon_trash_can
			click? <=> delete? null
	attr *
		^
		shm_hitalama_map_selectbox_dragged <= dragged_attr false
